import { CoreEnums } from '@/utils/domain/constants';

const { ActionType } = CoreEnums;

export const DEFAULT_TABS = [
  { name: 'configurations', drawer: false }, // Direct form, not a CardList drawer
  {
    name: 'approval',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    drawer: true,
  },
  // Approval sub-tabs (first level - parent: 'approval')
  {
    name: 'action-approval-general',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'approval',
  },
  {
    name: 'action-approval-rejection',
    type: [ActionType.CompleteInformation, ActionType.Approval, ActionType.DigitalSignature], // Only for CompleteInformation, Approval, DigitalSignature
    parent: 'approval',
  },
  {
    name: 'action-approval-deadline',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'approval',
  },
  {
    name: 'action-approval-filters',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    drawer: true, // This will show another CardList with filter options
    parent: 'approval',
  },
  // Approval Filters sub-tabs (second level - parent: 'action-approval-filters')
  {
    name: 'action-approval-filters-general',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-users',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-positions',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-areas',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-user-groups',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-external-users',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-agents',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-user-extra-fields',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-global-approvers',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-form-field-user-approvers',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
    parent: 'action-approval-filters',
  },
  {
    name: 'custom-notifications',
    field: 'isNotificationsEnabled',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.DigitalSignature,
      ActionType.SendEmail,
    ],
  },
  {
    name: 'notifications-mapping-attachments',
    field: 'isNotificationsEnabled',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.DigitalSignature,
      ActionType.SendEmail,
    ],
  },
  {
    name: 'email-template',
    field: 'isNotificationsEnabled',
    type: [
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.DigitalSignature,
      ActionType.SendEmail,
    ],
  },
  {
    name: 'pdf-template-generation-mapping',
    field: 'isPDFGenerationEnabled',
    type: [ActionType.CompleteInformation, ActionType.Approval, ActionType.GenerateDocuments],
  },
  { name: 'conditional', type: [ActionType.Conditional] },
  { name: 'execute-process-action', type: [ActionType.ExecuteProcessAction] },
  { name: 'switch', type: [ActionType.Switch] },
  { name: 'parallel', type: [ActionType.Parallel] },
  { name: 'run-code', type: [ActionType.RunCode] },
  { name: 'start-process-instance', type: [ActionType.StartProcessInstance] },
  { name: 'integration', type: [ActionType.Integration] },
  { name: 'execute-rpa-flow', type: [ActionType.ExecuteRpaFlow] },
  { name: 'consume-sequence', type: [ActionType.ConsumeSequence] },
  {
    name: 'webhook-mapping',
    type: [
      ActionType.DefaultInitial,
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
  },
  {
    name: 'action-webhook-general',
    type: [
      ActionType.DefaultInitial,
      ActionType.CompleteInformation,
      ActionType.Approval,
      ActionType.ExecuteTask,
      ActionType.DigitalSignature,
    ],
  },
  { name: 'action-behaviors', type: [ActionType.DefaultInitial, ActionType.CompleteInformation] },
  { name: 'digital-signature-field-mapping', type: [ActionType.DigitalSignature] },
  { name: 'response-status', type: [ActionType.ExecuteApiCall] },
  { name: 'api-call-send', type: [ActionType.ExecuteApiCall] },
  { name: 'api-call-response', type: [ActionType.ExecuteApiCall] },
  { name: 'set-variable', type: [ActionType.SetVariableData] },
  { name: 'set-form-data', type: [ActionType.SetFormData] },
  { name: 'action-entity-operation', type: [ActionType.DynamicEntityOperation] },
  { name: 'action-scheduled-execution', type: [ActionType.ScheduledExecution] },
  { name: 'action-iteration', type: [ActionType.Iterate] },
  { name: 'action-internal-operation', type: [ActionType.InternalOperation] },
  { name: 'action-generate-plain-text-file', type: [ActionType.GeneratePlainTextFile] },
  { name: 'action-import-plain-text-file', type: [ActionType.ImportPlainTextFile] },
  { name: 'action-automy-ai', type: [ActionType.AutomyAI] },
];
